var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiTranslatorWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.45,
    height: 23.711,
    viewBox: "0 0 19.45 23.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2221",
    "data-name": "Raggruppa 2221",
    transform: "translate(-13216.236 21543.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3520",
    "data-name": "Tracciato 3520",
    d: "M19.03,1.422a.938.938,0,0,0-1.321,0,.925.925,0,0,0,0,1.314l1.7,1.693H9.319c-.89,0-1.614,0-2.2.048a4.352,4.352,0,0,0-1.657.411A4.219,4.219,0,0,0,3.611,6.725,4.289,4.289,0,0,0,3.2,8.373c-.048.585-.048,1.3-.048,2.19v1.35a.934.934,0,0,0,1.868,0V10.6c0-.933,0-1.577.042-2.077a2.5,2.5,0,0,1,.216-.956A2.356,2.356,0,0,1,6.308,6.542a2.538,2.538,0,0,1,.961-.214c.5-.041,1.151-.042,2.089-.042H19.412l-1.7,1.693a.925.925,0,0,0,0,1.314.938.938,0,0,0,1.321,0l3.3-3.278a.925.925,0,0,0,0-1.314ZM22.6,14.1a.934.934,0,0,0-1.868,0V15.41c0,.933,0,1.577-.042,2.077a2.5,2.5,0,0,1-.216.956,2.356,2.356,0,0,1-1.033,1.027,2.538,2.538,0,0,1-.961.214c-.5.041-1.151.042-2.089.042H6.339l1.7-1.693a.925.925,0,0,0,0-1.313.938.938,0,0,0-1.321,0L3.424,20a.925.925,0,0,0,0,1.313l3.3,3.278a.938.938,0,0,0,1.321,0,.925.925,0,0,0,0-1.313l-1.7-1.693H16.431c.89,0,1.614,0,2.2-.048a4.353,4.353,0,0,0,1.657-.411,4.219,4.219,0,0,0,1.849-1.839,4.288,4.288,0,0,0,.413-1.648c.048-.585.048-1.3.048-2.19V14.1Z",
    transform: "translate(13213.086 -21544.639)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiTranslatorWhite);
export default __webpack_public_path__ + "static/media/ai-translator-white.c709bbf35a731fe9c74c3e053df36d02.svg";
export { ForwardRef as ReactComponent };